import { IStateTab } from './../../../global/types';
import { ICommand } from 'core-ts-types';
import { AccountDatasource } from '../../datasources/account_datasource';
import { IRootScopeService } from 'angular';
import { IState } from 'angular-ui-router';

export class ProfileMenuController {
  private tabs: IStateTab[] = [
    {
      state: 'my.profile.additional_information',
      label: 'Additional Information'
    },
    {
      state: 'my.profile.account_settings',
      label: 'Account Settings'
    }
  ];

  private selectedTab: IStateTab;

  private changeSelectedStateChange: () => void;

  constructor(
    private ngAccountDatasource: AccountDatasource,
    private logoutNotificationCommand: ICommand,
    private $state: ng.ui.IStateService,
    $rootScope: IRootScopeService
  ) {
    this.selectedTab = _.find(this.tabs, { state: this.$state.current.name });
    if (!this.selectedTab) {
      this.selectedTab = this.tabs[0];
    }
    this.changeSelectedStateChange = $rootScope.$on(
      '$stateChangeSuccess',
      this.changeSelectedTabOnLocationChange.bind(this)
    );
  }

  changeSelectedTabOnLocationChange(event: ng.IAngularEvent, toState: IState) {
    const newSelectedTab = _.find(this.tabs, { state: toState.name });
    if (!newSelectedTab) {
      return;
    }
    if (this.selectedTab.state !== newSelectedTab.state) {
      this.selectedTab = newSelectedTab;
    }
  }

  isCurrentState(stateName: string): boolean {
    return this.$state.includes(stateName);
  }

  tabSelectionChanged(event: any) {
    if (_.isUndefined(event.detail.value) || _.isNull(event.detail.value)) {
      return;
    }
    this.selectedTab = this.tabs[event.detail.value];
    if (!this.selectedTab || !this.selectedTab.state) {
      return;
    }
    this.$state.go(this.selectedTab.state);
  }

  $onDestroy() {
    this.changeSelectedStateChange();
  }

  logout(): void {
    this.logoutNotificationCommand();
  }
}

angular.module('capability-ng-user-app').controller('ngProfileMenuController', ProfileMenuController);



// WEBPACK FOOTER //
// ./app/lib/user_app/views/profile_menu/profile_menu.ts